<template>
  <div>
    <div v-for="piece in sectionPieces" :key="pieceIndexesMap[piece.id]" class="form-group">
      <step-piece
        :campaign-id="campaignId"
        :piece="piece"
        :piece-index="pieceIndexesMap[piece.id]"
        :step-id="stepId"
        :step-activity-type="stepActivityType"
        :first-step-id="firstStepId"
        :advanced-email-options="advancedEmailOptions"
        @disable-saving="$emit('disable-saving', $event)"
      ></step-piece>
    </div>
  </div>
</template>

<script>
import {createCampaignStepPieceIndexesMap} from '../../../utility/campaign/step/createCampaignStepPieceIndexesMap';
import StepPiece from './StepPiece';

export default {
  name: 'step-pieces',
  components: {
    StepPiece,
  },
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
    advancedEmailOptions: {
      type: Boolean,
    },
    pieces: {
      type: Array,
      required: true,
    },
    section: {
      type: String,
      default: undefined,
    },
    stepId: {
      type: Number,
      required: true,
    },
    stepActivityType: {
      type: String,
      required: true,
    },
    firstStepId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    pieceIndexesMap() {
      return createCampaignStepPieceIndexesMap(this.pieces);
    },
    sectionPieces() {
      if (!this.pieces) {
        return [];
      }

      return this.pieces.filter(
        piece => piece && piece.options && piece.options.input_type && !String(piece.name).startsWith('custom_scripts_')
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
